import React from "react";

export default function TagListHeader(props) {

  return (
    <li className="fk-table__item fk-table__item--heading">
      <div className="fk-table__item-name fk-table__item-name--first">
        Nome da tag
      </div>
      <div className="fk-table__item-name fk-table__item-name--second">
        Criada em
      </div>
      <div className="fk-table__item-name fk-table__item-name--third">
        Usuários
      </div>
      <div className="fk-table__item-name fk-table__item-name--lastone"></div>
    </li>
  );
}